// from: lodash
import _, { join, isArray, isNil, } from 'lodash';
export function maybeFillField(field, fn) {
    if (!isNil(field)) {
        fn(field);
    }
}
export function maybeFillArrayFiled(items, fn, separator = ',') {
    if (isArray(items)) {
        fn(join(items, separator));
    }
}
export function isFile(f) {
    if (!f) {
        return false;
    }
    return f instanceof File;
}
export async function normalizeResponseData(data) {
    if (!data) {
        return data;
    }
    if (!(data instanceof Blob)) {
        return data;
    }
    const text = await (new Response(data)).text();
    const needCoverter = data.type === 'application/json';
    if (needCoverter) {
        try {
            return JSON.parse(text);
        }
        catch (e) {
            console.error(e);
        }
    }
    else {
        return data;
    }
}
export function mapObjectValues(object, keys, fn) {
    if (!object) {
        return object;
    }
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const value = object[key];
        if (_.has(object, key)) {
            object = {
                ...object,
                [key]: fn(value),
            };
        }
    }
    return object;
}
export function serializeArray(arr) {
    if (_.isArray(arr)) {
        return _.join(arr, ',');
    }
    return arr;
}
export function cleanEmptyArray(object, ...keys) {
    if (!object) {
        return object;
    }
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const value = object[key];
        if (_.isArray(value) && _.isEmpty(value)) {
            object = _.omit(object, key);
        }
    }
    return object;
}
export function maybeSerializeArray(object, ...keys) {
    object = cleanEmptyArray(object, ...keys);
    return mapObjectValues(object, keys, serializeArray);
}
/**
 * 通用递归transform object/array工具
 * 可能替代方案: 注解+序列号, 暂时不用原因是需要class才行
 * todo: path的类型可以是template-literals
 * example:
const obj = {
    a: 'hello',
    b: {
        c: 'ccc',
        d: [
            { d1: 123 }
        ]
    }
}
const res = anyTransform(obj, (path, value) => {
    if (path === '.a') {
        return 'replace:a'
    } else if (path === '.b.c') {
        return 'replace:b.c'
    } else if (path === '.b.d.[].d1') {
        return 'replace:b.d.[].d1'
    }
    return value
})
res: {
    "a": "replace:a",
    "b": {
        "c": "replace:b.c",
        "d": [
            {
                "d1": "replace:b.d.[].d1"
            }
        ]
    }
}
 */
export function anyTransform(obj, replacer) {
    function loop(item, path) {
        item = replacer(path, item);
        if (_.isArray(item)) {
            return _.map(item, arrayItem => loop(arrayItem, path + '.[]'));
        }
        if (_.isObject(item)) {
            return _.mapValues(item, (value, key) => {
                return loop(value, path + '.' + key);
            });
        }
        return item;
    }
    return loop(obj, '');
}
export function maybeToArray(a) {
    if (_.isArray(a)) {
        return a;
    }
    else {
        return [a];
    }
}
export function safeConcat(...items) {
    items = _.filter(items, item => {
        return !_.isEmpty(item);
    });
    return _.concat(...items);
}
/**
 * 获取字符串长度，中文算2个长度
 */
export function getStringLengthAndCnDoubleLength(str = '') {
    // eslint-disable-next-line no-control-regex
    return str.replace(/[^\x00-\xff]/g, 'xx').length;
}
